import React, { useContext } from 'react';

import './PortfolioPlPerformanceChart.scss';
import TimeSeriesChart from 'utils/components/TimeSeriesChart/TimeSeriesChart';
import {
    useBpsFormat,
    useYScale,
} from 'utils/components/TimeSeriesChart/yAxis';
import { computeYDomain, getChartSeries, getHideSeriesClasses } from './series';
import AppContext from 'app/AppContext';
import { PortfolioPlPerformanceChartLegends } from 'widgets/portfolioPl/chart/performance/PortfolioPlPerformanceChartLegends';
import { PortfolioPlSubChartProps } from 'widgets/portfolioPl/chart/PortfolioPlChart';

export function PortfolioPlPerformanceChart(props: PortfolioPlSubChartProps) {
    const {
        config,
        width,
        dimensions,
        containerLeft,
        data: { timeSeries: data },
    } = props;

    const { leavesHidden, leavesCollapsed } = config;

    const displayXAxis = leavesHidden || leavesCollapsed;

    const yTicks = 6;

    const series = getChartSeries(data, width);
    const yDomain = computeYDomain(config, data);
    const yScale = useYScale(yDomain, [-1, +1]);
    const hideSeriesClasses = getHideSeriesClasses(config);

    const { numberFormat } = useContext(AppContext);
    const bpsFormat = useBpsFormat(numberFormat);

    const {
        performanceChart: { chartHeight, chartTop },
    } = dimensions;

    return (
        <>
            <PortfolioPlPerformanceChartLegends
                containerLeft={containerLeft}
                data={data}
                dimensions={dimensions}
            />
            <div
                className={`PortfolioPlPerformanceChart ${hideSeriesClasses}`}
                style={{
                    height: chartHeight + 'px',
                    top: chartTop + 'px',
                }}
            >
                <TimeSeriesChart
                    id="PortfolioPlPerformanceChart"
                    height={chartHeight}
                    data={data}
                    series={series}
                    displayXAxis={displayXAxis}
                    yScale={yScale}
                    yTicks={yTicks}
                    yTickFormat={bpsFormat}
                />
            </div>
        </>
    );
}
